/* eslint-disable no-console */
import { push } from 'react-router-redux';
import { delay } from 'redux-saga';
import { put, takeLatest, call, select, all } from 'redux-saga/effects';
import { PREFIX_LOCALE, locales, setNotification, getTranslated } from 'utils';
import * as CarrierApi from '../api/carrierApi';
import * as PropertyTypes from '../types/propertyTypes';
import * as PropertyApi from '../api/propertyApi';
import * as PropertyActions from '../actions/propertyActions';
import { getConfigurationsApi } from '../api/configurationApi';

const getProperty = state => state.property;
const getLayout = state => state.layout;

// A D D   N E W   P R O P E R T Y
function* attachedProperty(data) {
    yield CarrierApi.addPropertyToCarrierApi(data);
}

function* detachedProperty(data) {
    yield CarrierApi.deletePropertyToCarrierApi(data);
}

function* updatePropertyTranslate(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    let finalDescription = 'property.notification.newPropertyAddedSuccess';
    let type = 'add';

    const data = {
        property_id: action.data.property_id,
        reseller_id: action.data.reseller_id,
        property_type: action.data.property_type,
        description: '',
    };

    if (action.type === PropertyTypes.EDIT_PROPERTY) {
        type = 'edit';
        finalDescription = 'property.notification.propertyEditedSuccess';
    }

    for (let i = 0; i < locales.length; i += 1) {
        const lc = locales[i];

        if (lc !== 'en' || (lc === 'en' && action.type === PropertyTypes.EDIT_PROPERTY)) {
            try {
                const dataTrans = {
                    ...data,
                    ...action.data[lc],
                };

                const resultTrans = yield PropertyApi.updatePropertyTranslateApi(dataTrans);

                if (resultTrans.status !== 202) {
                    const error = yield resultTrans.json();
                    setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
                }
            } catch (e) {
                setNotification('error', locale, 'global.error', 'property.notification.translateError', { language: getTranslated(`locale.${lc}`, locale) });
                console.log(e);
            }
        }
    }

    yield put(PropertyActions.updateTranslateProperty(true));

    const loading = action.data.carriers && action.data.carriers.length !== 0;
    yield put(PropertyActions.updateTranslatePropertyRes(type, loading, true));

    if (action.type === PropertyTypes.EDIT_PROPERTY) {
        yield put(push('/factory/properties/'));
    }

    yield delay(500);
    yield put(PropertyActions.updateTranslatePropertyRes(type, false, false));

    setNotification('success', locale, 'global.success', finalDescription);
}

function* addNewPropertySaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const data = {
            property_id: action.data.property_id,
            reseller_id: action.data.reseller_id,
            ...action.data.en,
            unique_name: action.data.en.name,
            property_type: action.data.property_type,
            description: action.data.en.description || '',
        };

        const result = yield PropertyApi.addNewPropertyApi(data);
        if (result.status === 202) {
            yield put(PropertyActions.addNewPropertyRes(true));
            yield call(updatePropertyTranslate, action);

            const { carriers } = action.data;
            yield all(carriers.map(c => call(attachedProperty, {
                carrier_id: c,
                property_id: data.property_id,
            })));

            yield delay(carriers * 500);

            yield put(PropertyActions.addNewPropertyRes(false));

            yield put(PropertyActions.goToStepOfPropertyForm(1, action.data.property_id));
            yield put(PropertyActions.setSelectedProperty({
                id: action.data.property_id,
                property_type: action.data.property_type,
                name: {
                    original_name: action.data.en.name,
                    translate: [
                        {
                            language: 'be_en',
                            value: action.data.en.name,
                        },
                        {
                            language: 'be_fr',
                            value: action.data.fr.name,
                        },
                        {
                            language: 'be_nl',
                            value: action.data.nl.name,
                        },
                    ],
                },
            }));
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });

            yield put(PropertyActions.addNewPropertyErr(error.message));
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'property.notification.addingNewPropertyError');
        yield put(PropertyActions.addNewPropertyErr());
        console.log(e);
    }
}

export function* addPropertyWatcher() {
    yield takeLatest(PropertyTypes.ADD_NEW_PROPERTY, addNewPropertySaga);
}
// A D D   N E W   P R O P E R T Y


// L O A D   P R O P E R T I E S
function* loadPropertiesSaga() {
    try {
        const property = yield select(getProperty);
        const { offset, limit } = property;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['property_value']),
        };

        const filter = {};

        if (property.filters.name !== '') {
            filter['name.translate.value'] = {
                operator: 'typing',
                value: property.filters.name,
            };
        }

        if (property.filters.property_type.length !== 0) {
            filter.property_type = property.filters.property_type;
        }

        params.filter = JSON.stringify(filter);

        if (property.sort !== null) {
            params.sort_by = JSON.stringify({ 'name.original_name': property.sort.type === 'asc' ? 1 : -1 });
        } else {
            params.sort_by = JSON.stringify({ created_at: -1 });
        }

        const result = yield PropertyApi.getPropertiesApi(params);
        yield put(PropertyActions.loadPropertiesRes(result.data));
    } catch (e) {
        yield put(PropertyActions.loadPropertiesErr());
        console.log(e);
    }
}

export function* loadPropertyWatcher() {
    yield takeLatest(PropertyTypes.LOAD_PROPERTIES, loadPropertiesSaga);
}
// L O A D   P R O P E R T I E S


// P R O P E R T I E S   T Y P E   F I L T E R
function* setPropertyTypeFiltersSaga(action) {
    try {
        const property = yield select(getProperty);
        const { offset, limit, filters } = property;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['property_value']),
        };

        if (!filters.name) {
            params.filter = JSON.stringify({
                'name.translate.value': {
                    operator: 'typing',
                    value: filters.name,
                },
                property_type: action.key,
            });
        } else {
            params.filter = JSON.stringify({
                'name.translate.value': {
                    operator: 'typing',
                    value: filters.name,
                },
            });
        }

        if (action.key.length !== 0) {
            params.filter = JSON.stringify({
                'name.translate.value': {
                    operator: 'typing',
                    value: filters.name,
                },
                property_type: action.key,
            });
        } else {
            params.filter = JSON.stringify({
                'name.translate.value': {
                    operator: 'typing',
                    value: filters.name,
                },
            });
        }

        const result = yield PropertyApi.getPropertiesApi(params);
        yield put(PropertyActions.setPropertyTypeFiltersRes(result.data));
    } catch (e) {
        yield put(PropertyActions.loadPropertiesErr());
        console.log(e);
    }
}

export function* setPropertyTypeFilterWatcher() {
    yield takeLatest(PropertyTypes.SET_PROPERTY_TYPE_FILTER, setPropertyTypeFiltersSaga);
}
// P R O P E R T I E S   T Y P E   F I L T E R


// F I L T E R   P R O P E R T I E S
function* setPropertyFiltersSaga(action) {
    try {
        const property = yield select(getProperty);
        const { offset, limit } = property;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['property_value']),
        };

        if (property.filters.property_type.length !== 0) {
            params.filter = JSON.stringify({
                [`${action.key}.translate.value`]: {
                    operator: 'typing',
                    value: action.value,
                },
                property_type: property.filters.property_type,
            });
        } else {
            params.filter = JSON.stringify({
                [`${action.key}.translate.value`]: {
                    operator: 'typing',
                    value: action.value,
                },
            });
        }

        const result = yield PropertyApi.getPropertiesApi(params);
        yield put(PropertyActions.setPropertyFiltersRes(result.data));
        yield call(delay, 500);
    } catch (e) {
        yield put(PropertyActions.loadPropertiesErr());
        console.log(e);
    }
}

export function* setPropertyFilterWatcher() {
    yield takeLatest(PropertyTypes.SET_PROPERTY_FILTER, setPropertyFiltersSaga);
}
// F I L T E R   P R O P E R T I E S


// R E S E T    F I L T E R    P R O P E R T I E S
function* resetFiltersPropertiesSaga() {
    try {
        const property = yield select(getProperty);
        const { offset, limit } = property;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['property_value']),
        };

        const result = yield PropertyApi.getPropertiesApi(params);
        yield put(PropertyActions.resetFiltersPropertiesRes(result.data));
    } catch (e) {
        console.log(e);
        yield put(PropertyActions.loadPropertiesErr());
    }
}

export function* resetFiltersPropertiesWatcher() {
    yield takeLatest(PropertyTypes.RESET_FILTER_PROPERTIES, resetFiltersPropertiesSaga);
}
// R E S E T    F I L T E R    P R O P E R T I E S


// L O A D   E D I T A B L E   P R O P E R T Y
function* loadEditablePropertySaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const paramsCarrier = {
            filter: JSON.stringify({ property: [action.id] }),
        };

        const resultCarriers = yield CarrierApi.getCarriersApi(paramsCarrier);

        const paramsProperty = {
            filter: JSON.stringify({ id: action.id }),
        };

        const resultProperty = yield PropertyApi.getPropertiesApi(paramsProperty);

        if (resultProperty.data.hits.length > 0) {
            const hit = resultProperty.data.hits[0];
            hit.carriers = resultCarriers.data.hits;
            yield put(PropertyActions.loadEditablePropertyRes(hit));
        } else {
            yield put(push('/404'));
            yield put(PropertyActions.loadEditablePropertyRes(null));
        }
    } catch (e) {
        yield put(PropertyActions.loadEditablePropertyErr());
        setNotification('error', locale, 'global.error', 'property.notification.loadPropertyWithCarriersError');
        console.log(e);
    }
}

export function* loadEditablePropertyWatcher() {
    yield takeLatest(PropertyTypes.LOAD_EDITABLE_PROPERTY, loadEditablePropertySaga);
}
// L O A D   E D I T A B L E   P R O P E R T Y


// E D I T   P R O P E R T Y
function* editPropertySaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield PropertyApi.editPropertyApi(action.data);

        const { newCarriers, deletedCarriers } = action.data;

        if (result.status === 202) {
            yield call(updatePropertyTranslate, action);

            yield all(newCarriers.map(c => call(attachedProperty, {
                carrier_id: c,
                property_id: action.data.property_id,
            })));

            yield all(deletedCarriers.map(c => call(detachedProperty, {
                carrier_id: c,
                property_id: action.data.property_id,
            })));

            yield delay((newCarriers.length + deletedCarriers.length) * 500);
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'property.notification.loadPropertyWithCarriersError');
        yield put(PropertyActions.editPropertyErr());
        console.log(e);
    }
}

export function* editPropertyWatcher() {
    yield takeLatest(PropertyTypes.EDIT_PROPERTY, editPropertySaga);
}
// E D I T   P R O P E R T Y


// L O A D   P R O P E R T Y   V A L U E S
function* loadPropertyValuesSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const property = yield select(getProperty);
        const { offset, limit } = property.listPropertyValues;

        const params = {
            filter: JSON.stringify({ property: action.propertyID }),
            offset,
            limit,
        };

        const result = yield PropertyApi.getPropertyValuesApi(params);

        yield put(PropertyActions.loadPropertyValuesRes(result.data));

        if (action.pv) {
            const propertyValue = (result.data?.hits || []).find(pv => pv.id === action.pv);

            if (propertyValue) {
                yield put(PropertyActions.setEditablePropertyValue(propertyValue));
            }
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'propertyValue.notification.loadingPropertyValuesError');
        yield put(PropertyActions.loadPropertyValuesErr());
        console.log(e);
    }
}

export function* loadPropertyValuesWatcher() {
    yield takeLatest(PropertyTypes.LOAD_PROPERTY_VALUES, loadPropertyValuesSaga);
}
// L O A D   P R O P E R T Y   V A L U E S


// S E T   P R O P E R T Y   V A L U E S   F I L T E R S
function* setPropertyValuesFiltersSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const property = yield select(getProperty);

        const { offset, limit } = property.listPropertyValues;

        const params = {
            offset,
            limit,
            filter: JSON.stringify({
                property: property.selected.data.id,
                'name.translate': {
                    elementMatch: {
                        value: {
                            operator: 'typing',
                            value: action.value,
                        },
                        language: `${PREFIX_LOCALE}${locale}`,
                    },
                },
            }),
        };

        const result = yield PropertyApi.getPropertyValuesApi(params);

        yield put(PropertyActions.setPropertyValuesFiltersRes(result.data));
    } catch (e) {
        setNotification('error', locale, 'global.error', 'propertyValue.notification.loadingPropertyValuesFilterError');
        yield put(PropertyActions.loadPropertyValuesErr());
        console.log(e);
    }
}

export function* setPropertyValuesFiltersWatcher() {
    yield takeLatest(PropertyTypes.SET_PROPERTY_VALUES_FILTERS, setPropertyValuesFiltersSaga);
}
// S E T   P R O P E R T Y   V A L U E S   F I L T E R S


// A D D   P R O P E R T Y   V A L U E   T O   P R O P E R T Y
function* updatePropertyValueTranslate(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    const data = {
        property_id: action.data.property_id,
        property_value_id: action.data.property_value_id,
        reseller_id: action.data.reseller_id,
    };

    const params = { bulk: [] };
    locales.forEach((lc) => {
        if (lc !== 'en' || (lc === 'en' && action.type === PropertyTypes.EDIT_PROPERTY_VALUE_TO_PROPERTY)) {
            params.bulk.push({
                ...action.data[lc],
                ...data,
            });
        }
    });

    const result = yield PropertyApi.updatePropertyValueTranslateApi(params);

    if (result.status !== 202) {
        const error = yield result.json();
        setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
    }

    if (action.type === PropertyTypes.EDIT_PROPERTY_VALUE_TO_PROPERTY) {
        setNotification('success', locale, 'global.success', 'propertyValue.notification.propertyValueEditedSuccess');

        yield put(PropertyActions.editPropertyValueToPropertyRes(true));
        yield put(PropertyActions.editPropertyValueToPropertyRes(false));
    } else {
        setNotification('success', locale, 'global.success', 'propertyValue.notification.newPropertyValueAddedSuccess');

        yield put(PropertyActions.addPropertyValueToPropertyRes(true));
        yield put(PropertyActions.addPropertyValueToPropertyRes(false));
    }

    yield put(PropertyActions.setEditablePropertyValue(null));

    yield call(loadPropertyValuesSaga, { propertyID: data.property_id });
}

function* addPropertyValueToPropertySaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const data = {
            ...action.data.en,
            ...action.data,
        };

        const result = yield PropertyApi.addPropertyValueToPropertyApi(data);

        if (result.status === 202) {
            yield call(updatePropertyValueTranslate, action);
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });

            yield put(PropertyActions.addPropertyValueToPropertyErr(error.message));
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'propertyValue.notification.addingNewPropertyValueError');
        yield put(PropertyActions.addPropertyValueToPropertyErr());
        console.log(e);
    }
}

export function* addPropertyValueToPropertyWatcher() {
    yield takeLatest(PropertyTypes.ADD_PROPERTY_VALUE_TO_PROPERTY, addPropertyValueToPropertySaga);
}
// A D D   P R O P E R T Y   V A L U E   T O   P R O P E R T Y


// E D I T   P R O P E R T Y   V A L U E   T O   P R O P E R T Y
function* editPropertyValueToPropertySaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield PropertyApi.editPropertyValueToPropertyApi(action.data);

        if (result.status === 202) {
            yield call(updatePropertyValueTranslate, action);
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });

            yield put(PropertyActions.editPropertyValueToPropertyErr(error.message));
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'propertyValue.notification.editingPropertyValueError');
        console.log(e);
    }
}

export function* editPropertyValueToPropertyWatcher() {
    yield takeLatest(PropertyTypes.EDIT_PROPERTY_VALUE_TO_PROPERTY, editPropertyValueToPropertySaga);
}
// E D I T   P R O P E R T Y   V A L U E   T O   P R O P E R T Y


// L O A D   P R O P E R T Y   F O R   E D I T I N G   P R O P E R T Y   V A L U E S
function* loadPropertyForEditingPropertyValuesSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const params = {
            filter: JSON.stringify({ id: action.id }),
        };

        const result = yield PropertyApi.getPropertiesApi(params);

        if (result.data.hits.length === 1) {
            yield put(PropertyActions.setSelectedProperty(result.data.hits[0]));
            yield put(PropertyActions.loadPropertyForEditingPropertyValuesRes());
        } else {
            setNotification('error', locale, 'global.error', 'property.notification.propertyDoesntExistError');
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'property.notification.loadPropertyError');
        yield put(PropertyActions.loadPropertyForEditingPropertyValuesErr());
        console.log(e);
    }
}

export function* loadPropertyForEditingPropertyValuesWatcher() {
    yield takeLatest(PropertyTypes.LOAD_PROPERTY_FOR_EDITING_PROPERTY_VALUES, loadPropertyForEditingPropertyValuesSaga);
}
// L O A D   P R O P E R T Y   F O R   E D I T I N G   P R O P E R T Y   V A L U E S


// D E L E T E   P R O P E R T Y   V A L U E
function* deletePropertyValueSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const data = {
            property_id: action.propertyId,
            property_value_id: action.propertyValueId,
        };

        const resultConfiguration = yield getConfigurationsApi({ filter: JSON.stringify({
            'configuration_property.property_value_id': action.propertyValueId,
        }) });

        if (resultConfiguration.data.hits.length === 0) {
            const result = yield PropertyApi.deletePropertyValueApi(data);

            if (result.status === 202) {
                yield put(PropertyActions.deletePropertyValueRes());
                yield call(loadPropertyValuesSaga, { propertyID: action.propertyId });
            } else {
                const error = yield result.json();
                setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });

                yield put(PropertyActions.deletePropertyValueErr());
            }
        } else {
            setNotification('error', locale, 'global.error', 'propertyValue.delete.inUseError');
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'propertyValue.notification.deletePropertyValueError');
        yield put(PropertyActions.deletePropertyValueErr());
        console.log(e);
    }
}

export function* deletePropertyValueWatcher() {
    yield takeLatest(PropertyTypes.DELETE_PROPERTY_VALUE, deletePropertyValueSaga);
}
// D E L E T E   P R O P E R T Y   V A L U E
